import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CardHeader from './CardHeader';
import MentionsInput from '../components/MentionsInput';
import CardTagLine from './CardTagLine';
import Avatar from './Avatar';
import Dropdown from './Dropdown';
import CommentCard from '../components/CommentCard';
import axios from '../lib/axios';
import qs from 'qs';

export default class DiscussionCard extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    body_markdown: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    author: PropTypes.object.isRequired,
    posted_on: PropTypes.string.isRequired,
    posted_on_words: PropTypes.string.isRequired,
    is_favorited: PropTypes.bool.isRequired,
    toggle_favorite_url: PropTypes.string.isRequired,
    is_search_card: PropTypes.bool,
    comments: PropTypes.array.isRequired,
    submit_comment_url: PropTypes.string.isRequired,
    max_visible_comments: PropTypes.number,
    comments_collapsed: PropTypes.bool,
    vote_count: PropTypes.number.isRequired,
    current_user: PropTypes.object.isRequired,
    useTimezone: PropTypes.string,
    collapsed: PropTypes.bool,
    tags: PropTypes.array,
    maxTags: PropTypes.number,
    disable_comments: PropTypes.bool.isRequired,
    highlightedCommentId: PropTypes.string,
  };

  static defaultProps = {
    tags: [],
    maxTags: 3,
    useTimezone: moment.tz.guess(),
    max_visible_comments: 3,
    collapsed: true,
    comments_collapsed: true,
    is_search_card: false,
    highlightedCommentId: null,
  };

  constructor(props) {
    super(props);

    this.textAreaRef = React.createRef();
    this.state = {
      comments: this.props.comments,
      new_comment_value: '',
      update_new_comment_value: false,
      is_favorited: this.props.is_favorited,
      vote_count: this.props.vote_count,
      collapsed: this.props.collapsed,
      comments_collapsed: this.props.comments_collapsed,
      max_visible_comments: this.props.max_visible_comments,
    };
  }

  handleCommentClick = () => {
    this.textAreaRef.current.focus();
    // mobile safari ignores these options and just assumes true.
    this.textAreaRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  handleFavoriteClick = () => {
    axios.get(this.props.toggle_favorite_url).then(() => {
      this.setState({
        is_favorited: !this.state.is_favorited,
        vote_count: this.state.is_favorited ? this.state.vote_count - 1 : this.state.vote_count + 1,
      });
    });
  };

  handleSubmitComment = (e) => {
    e.preventDefault();
    if (this.state.new_comment_value !== '') {
      axios
        .post(this.props.submit_comment_url, { comment: { body: this.state.new_comment_value } })
        .then((response) => {
          const { data } = response;
          this.setState({
            comments: data.comments,
            new_comment_value: '',
            update_new_comment_value: true,
          });
        });
    }
  };

  handleCommentValueChange = (value) => {
    this.setState({ new_comment_value: value, update_new_comment_value: value === '' });
  };

  handleCommentsCollapseToggle = () => {
    this.setState({ comments_collapsed: !this.state.comments_collapsed });
  };

  handleCollapseToogle = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  updateComments = (data) => {
    this.setState({ comments: data.comments });
  };

  renderTags() {
    return (
      <CardTagLine
        className="u-mt-2 md:u-mt-5"
        seeMoreURL={this.props.url}
        tags={this.props.tags}
        maxTags={this.props.maxTags}
        keyIdentifier={this.props.title}
      />
    );
  }

  renderDropdownTrigger() {
    return (
      <span className="u-text-grey">
        <i className="Icon-more u-flex u-color-grey u-items-center" />
      </span>
    );
  }

  componentDidMount() {
    const params = qs.parse(window.location.search.slice(1));
    if (params.comment) {
      $(document).scrollTop($(`#comment-${params.comment}`).offset().top);
    }
  }

  render() {
    const comments = this.state.comments_collapsed
      ? this.state.comments.slice(-this.state.max_visible_comments)
      : this.state.comments;

    const commentsCount = this.state.comments.reduce((acc, item) => {
      acc += 1 + item.children.length;
      return acc;
    }, 0);
    let commentsCounter;
    if (commentsCount !== 1) {
      commentsCounter = `${commentsCount} Comments`;
    } else if (commentsCount === 1) {
      commentsCounter = '1 Comment';
    }

    let votesCounter;

    if (this.state.vote_count !== 1) {
      votesCounter = `${this.state.vote_count} Favorites`;
    } else if (this.state.vote_count === 1) {
      votesCounter = '1 Favorite';
    }

    return (
      <div
        className="Card-v2"
        data-card-type={this.props.type}
        data-card-author={this.props.author.name}
        data-card-title={this.props.title}>
        <div className="Card-v2-section Card-v2-header u-bg-grey-lightest u-border-b u-border-grey-lighter u-mb-6 u-rounded-t">
          <div className="u-flex u-w-full u-justify-between">
            <CardHeader
              className="u-overflow-hidden"
              author={this.props.author}
              posted_on={this.props.posted_on}
              posted_on_words={this.props.posted_on_words}
              useTimezone={this.props.useTimezone}
              title={this.props.title}
              url={this.props.url}
              label="Discussion"
            />
          </div>
        </div>
        <div className="Card-v2-section u-mb-6">
          <div className="Card-v2-description Readability">
            {/* {this.state.collapsed && this.props.summary !== this.props.body_markdown && (
              <div>
                <div dangerouslySetInnerHTML={{ __html: this.props.summary }} />
                <span
                  className="hover:u-underline u-cursor-pointer u-font-semibold u-text-old-primary-color-blue"
                  onClick={this.handleCollapseToogle}>
                  Read more
                </span>
              </div>
            )}
            {!this.state.collapsed && this.props.summary !== this.props.body_markdown && (
              <div>
                <div dangerouslySetInnerHTML={{ __html: this.props.body_markdown }} />
                {this.props.collapsed && (
                  <span
                    className="hover:u-underline u-cursor-pointer u-font-semibold u-text-old-primary-color-blue"
                    onClick={this.handleCollapseToogle}>
                    Read less
                  </span>
                )}
              </div>
            )}
            {this.props.summary === this.props.body_markdown && (
              <div dangerouslySetInnerHTML={{ __html: this.props.body_markdown }} />
            )} */}
            <div dangerouslySetInnerHTML={{ __html: this.props.body_markdown }} />
          </div>
          <div className="u-flex u-flex-row u-items-end">
            <div className="u-flex u-flex-1">{this.renderTags()}</div>
          </div>
        </div>
        <div className="u-flex u-items-center u-justify-between u-px-6 u-py-3 u-bg-grey-lightest u-border-t u-border-grey-lighter">
          <div>
            {!this.props.is_search_card && (
              <div className="u-flex">
                {!this.props.disable_comments && (
                  <div
                    className="u-text-old-primary-color-blue u-cursor-pointer u-flex u-items-center u-text-sm u-mr-2"
                    onClick={this.handleCommentClick}>
                    <i className="Icon-comment u-flex u-items-center u-mr-2" />{' '}
                    <span className="u-font-semibold">Comment</span>
                  </div>
                )}
                <div
                  className="u-text-old-primary-color-blue u-cursor-pointer u-flex u-items-center u-text-sm"
                  onClick={this.handleFavoriteClick}>
                  {this.state.is_favorited && (
                    <i className="Icon-favorite-full u-flex u-items-center u-mr-2" />
                  )}
                  {!this.state.is_favorited && (
                    <i className="Icon-favorite u-flex u-items-center u-mr-2" />
                  )}
                  <span className="u-font-semibold">Favorite</span>
                </div>
              </div>
            )}
          </div>
          <div className="u-hidden md:u-flex u-justify-end u-items-center">
            <div className="u-flex u-items-center u-ml-2 u-text-grey u-font-semibold">
              {!this.props.disable_comments && (
                <div className="u-text-sm u-mr-2">{commentsCounter}</div>
              )}
              <span className="u-text-sm">{votesCounter}</span>
            </div>
          </div>
        </div>
        {!this.props.is_search_card && !this.props.disable_comments && (
          <div className="u-border-t u-border-grey-lighter u-px-6 u-py-2">
            {this.state.comments.length > 3 && this.state.comments_collapsed && (
              <div
                className="u-text-grey u-cursor-pointer u-text-xs u-mt-2 u-mb-3 hover:u-underline"
                onClick={this.handleCommentsCollapseToggle}>
                View {this.state.comments.length - 3} more comments
              </div>
            )}
            {this.state.comments.length > 3 && !this.state.comments_collapsed && (
              <div
                className="u-text-grey u-cursor-pointer u-text-xs u-mt-2 u-mb-3 hover:u-underline"
                onClick={this.handleCommentsCollapseToggle}>
                View less comments
              </div>
            )}
            {this.state.comments.length > 0 &&
              comments.map((comment) => (
                <CommentCard
                  key={comment.id}
                  highlighted={comment.id === this.props.highlightedCommentId}
                  replyUrl={this.props.submit_comment_url}
                  onUpdate={this.updateComments}
                  onDelete={this.updateComments}
                  {...comment}
                />
              ))}
            <div className="u-flex u-items-center u-my-2">
              <Avatar
                src={this.props.current_user.avatar}
                href={this.props.current_user.url}
                name={this.props.current_user.full_name}
                className="u-h-8 u-w-8 u-mr-4"
              />
              <div className="u-w-full">
                <form
                  onSubmit={this.handleSubmitComment}
                  className="u-w-full u-flex u-items-center">
                  <MentionsInput
                    style={{ minHeight: 30 }}
                    isComment
                    toolbarAlwaysInvisible
                    rows={1}
                    clear={this.state.update_new_comment_value}
                    value={this.state.new_comment_value}
                    onChange={(value) => this.handleCommentValueChange(value)}
                    innerRef={this.textAreaRef}
                    apiUserUrl="/api/v1/users"
                    apiCompanyUrl="/api/v1/companies"
                    placeholder="Add a comment..."
                    className="u-w-full u-mb-0 u-border-grey-lighter u-rounded u-resize-none u-text-sm"
                  />
                  <div className="u-ml-3">
                    <button className="Button u-py-2 u-px-4 Button--noMargins" type="submit">
                      Post
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
